import React, { useEffect } from "react"
import s from "./comingSoonWall.module.scss"

const ComingSoonWall = () => {
	useEffect(() => {
		const { body } = document
		const html = document.documentElement
		const prevBody = body.style.overflow
		const prevHtml = html.style.overflow
		body.style.overflow = "hidden"
		html.style.overflow = "hidden"
		return () => {
			body.style.overflow = prevBody
			html.style.overflow = prevHtml
		}
	}, [])

	return (
		<div className={s.wall} role="main" aria-labelledby="coming-soon-title">
			<div className={s.stack}>
				<img
					className={s.logo}
					src="/static/img/logos/hape_rebrand_logo_white.svg"
					alt="HAPE"
				/>
				<h1 id="coming-soon-title" className={s.title}>
					Coming Soon
				</h1>
			</div>
		</div>
	)
}

export default ComingSoonWall
